exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-settings[data-v-1b7262fe]{width:100%;max-width:200px;display:block;margin:0 auto}.vc-question-title[data-v-1b7262fe]{max-width:685px}@media screen and (max-width:1199px){.vc-question-title[data-v-1b7262fe]{max-width:545px}}.vc-toggle-wrapper[data-v-1b7262fe]{margin-left:6px}.tab-medical-course-name[data-v-1b7262fe]{font-size:13px}.tab-doctor-menu-title[data-v-1b7262fe]{font-size:15px;font-weight:700}.tabContentBody[data-v-1b7262fe]{position:relative;padding-bottom:120px}.tabContentImportExport[data-v-1b7262fe]{position:absolute;right:20px;bottom:20px}", ""]);

// exports
